import React from 'react';
import clsx from 'clsx';
import { useReviewOffer } from 'components/ReviewOffer/ReviewOffer.context';
import { Offer } from 'components/SummaryCard/SummaryCard.helpers';
import styles from '../../SummaryCard.module.css';

export const Label = ({ labelText }: { labelText: string }) => {
  const { offerDecision } = useReviewOffer();

  return (
    <p
      className={clsx(styles.label, {
        [styles.unselectedValue]: offerDecision === Offer.REJECT,
      })}
    >
      {labelText}
    </p>
  );
};
